module.exports = __webpack_public_path__ + "static/media/Papyrus.89c08872.jpg";